import { localStorageKeys } from 'src/constants/localStorageKeys'
import { LocalStorageService } from '../../libraries/localStorage'
import { ListFilter } from '../../views/types/utils/ListFilter'

const localStorageService = new LocalStorageService<ListFilter>()

/**
 * @deprecated [新規の利用は非推奨]
 * - 一覧系画面の絞り込み条件をローカルストレージに保存したり、読み出したりするときに使う関数
 * - 宣言的に利用できるhooksっぽく書いてあるが、単なる同期的・命令的な関数である
 * - setListFilterを実行しても再レンダリングは走らないので、利用側コンポーネントでfiltersの値が常に最新であることは保証されない
 *
 * @see useListPagination ページネーション部分の移行先。フィルタ条件は各画面のTanStack Query移行時に個別管理する。
 */
export const useListFilter = () => {
  const filters = localStorageService.getItem(localStorageKeys.listFilter)

  const setListFilter = (updatedFilters: ListFilter) => {
    localStorageService.setItem(localStorageKeys.listFilter, updatedFilters)
  }

  return { filters, setListFilter }
}
